import FormCampaign from "../campaign-form";

export const CreateCampaign = () => {
  return <FormCampaign />;
};

export default CreateCampaign;
